import Col from "components/ui-elements/Col";
import React from "react";
import InputMultiple from "./InputMultiple";
const InputMultipleCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <InputMultiple {...rest} />
    </Col>
  );
};

InputMultipleCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-1"
}

export default InputMultipleCol;